function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { DeleteOutlined, FileIcon } from '@aelf-design/icons';
import { Upload as AntdUpload, Image } from 'antd';
import { useTheme } from 'antd-style';
import UploadButton from "../UploadButton";
import useStyles from "./style";
var StatusList = ['done', 'uploading'];
function UploadItemRender(_ref) {
  var _file$response;
  var file = _ref.file,
    actions = _ref.actions;
  var _useStyles = useStyles(),
    styles = _useStyles.styles,
    cx = _useStyles.cx;
  var token = useTheme();
  return file.url || file.thumbUrl ? StatusList.includes(file.status) && /*#__PURE__*/React.createElement("div", {
    className: cx(styles.previewContainer)
  }, /*#__PURE__*/React.createElement(Image, {
    height: 202,
    width: "100%",
    className: "preview-img",
    src: (file === null || file === void 0 || (_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.url) || file.url || file.thumbUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: "file-info"
  }, file.status === 'done' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('fileName')
  }, file.name), /*#__PURE__*/React.createElement("div", {
    className: "clear-container",
    onClick: function onClick() {
      actions.remove();
    }
  }, /*#__PURE__*/React.createElement(DeleteOutlined, {
    color: token.colorPrimary,
    hoverColor: token.colorPrimaryHover,
    activeColor: token.colorPrimaryActive
  }), /*#__PURE__*/React.createElement("span", {
    className: "clear-text"
  }, "Delete"))) : /*#__PURE__*/React.createElement("div", null, "Uploading..."))) || null : /*#__PURE__*/React.createElement("div", {
    className: cx(styles.FilePreviewContainer)
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-icon-container"
  }, /*#__PURE__*/React.createElement(FileIcon, null), /*#__PURE__*/React.createElement("div", {
    className: "file-tips"
  }, "Ready for review")), /*#__PURE__*/React.createElement("div", {
    className: "file-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('fileName')
  }, file.name), /*#__PURE__*/React.createElement("div", {
    className: "clear-container",
    onClick: function onClick() {
      actions.remove();
    }
  }, /*#__PURE__*/React.createElement(DeleteOutlined, {
    color: token.colorPrimary,
    hoverColor: token.colorPrimaryHover,
    activeColor: token.colorPrimaryActive
  }), /*#__PURE__*/React.createElement("span", {
    className: "clear-text"
  }, "Remove"))));
}
var InternalUpload = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useStyles2 = useStyles(),
    styles = _useStyles2.styles,
    cx = _useStyles2.cx,
    prefixCls = _useStyles2.prefixCls;
  var tips = props.tips,
    _props$showUploadButt = props.showUploadButton,
    showUploadButton = _props$showUploadButt === void 0 ? true : _props$showUploadButt,
    uploadText = props.uploadText,
    uploadIconColor = props.uploadIconColor;
  return /*#__PURE__*/React.createElement("div", {
    className: (cx(prefixCls + '-upload-container'), styles.AelfdUploadContainer)
  }, /*#__PURE__*/React.createElement(AntdUpload, _extends({}, props, {
    listType: "picture-card",
    ref: ref,
    itemRender: function itemRender(originNode, file, fileList, actions) {
      return /*#__PURE__*/React.createElement(UploadItemRender, {
        originNode: originNode,
        file: file,
        fileList: fileList,
        actions: actions
      });
    }
  }), showUploadButton && /*#__PURE__*/React.createElement(UploadButton, {
    uploadIconColor: uploadIconColor,
    tips: tips,
    uploadText: uploadText
  })));
});
InternalUpload.displayName = 'Upload';
var Upload = InternalUpload;
Upload.LIST_IGNORE = AntdUpload.LIST_IGNORE;
export default Upload;